export default __webpack_public_path__ + "static/media/app_role.48ecdbe2.png";